import { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

function SharedDialog({
  title,
  subtitle,
  children,
  isOpen,
  handleClose,
  width,
}: {
  title: string;
  subtitle: string;
  children: any;
  isOpen: boolean;
  handleClose: any;
  width?: "xs" | "lg" | "md" | "sm" | "xl";
}) {
  return (
    <Dialog
      fullWidth
      maxWidth={width ?? "lg"}
      open={isOpen}
      onClose={handleClose}
    >
      <DialogTitle id="max-width-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{subtitle}</DialogContentText>
        {children}
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}

export default SharedDialog;

export function SharedDialogControls({ children }: { children: ReactNode }) {
  return (
    <div className="k-form-buttons" style={{ justifyContent: "flex-end" }}>
      {children}
    </div>
  );
}
